import { FC } from 'react';
import { H1 } from '../../components';
import Container from './Container';
import FeatureBlocks, { FeatureDescription } from '../FeatureBlocks';
import { businessPageQuery } from '../../core-types';
import { BlockContent } from '../../components/BlockContent';

type Props = {
  data: businessPageQuery;
  appContent: boolean;
};

const Business: FC<Props> = ({ data, appContent }) => {
  const { system, businessPage } = data;

  if (!system || !businessPage) {
    return null;
  }

  return (
    <>
      {!appContent && (
        <Container textAlign="center" mb="lg" maxWidth="none">
          <H1 typoStyle="xl" mt="lg" mb="sm">
            {businessPage.heading || businessPage.title}
          </H1>
          <FeatureDescription>
            <BlockContent blocks={businessPage.description} />
          </FeatureDescription>
        </Container>
      )}
      <FeatureBlocks
        featureBlocks={businessPage.featureBlocks}
        appContent={appContent}
      />
    </>
  );
};

export default Business;
